export default {"src":"/_next/static/media/file_upload_arrow.3696da76.svg","height":40,"width":29,"blurWidth":0,"blurHeight":0};